import React from 'react';
import ModalHeader from '../ModalHeader';
import ModalFooter from '../ModalFooter';

const RemoveDocument = () => {
    return (
        <>
            <ModalHeader />

            <div className="modal__content">
                <h2>Möchten Sie den Zahlungsauftrag zurückziehen?</h2>
            </div>

            <ModalFooter buttons={[{type: 'abort'}, {type: 'confirm'}]} spread={true} />
        </>
    );
};

export default RemoveDocument;
